export { default } from './CarListCard';
